import {
  Text as MantineText,
  TextProps as MantineTextProps,
} from '@mantine/core';

export type TextProps = MantineTextProps;

export const Text = MantineText as typeof MantineText;

Text.displayName = 'Text';
